import React from 'react';
import { Center, Card } from '@mantine/core';
import { SubmittableClient } from '../../../backend/models/client';
import ClientForm from './Form';
import { addClient } from '../../Util/server';
import { useLoaderData } from 'react-router-dom';
import { AggregatedDataLoaderResult } from '../../Loaders/AggregatedDataLoader';

const NewClient = () => {
  const { technologies, clients, persons } = useLoaderData() as AggregatedDataLoaderResult;
  return (
    <Center>
      <Card
        withBorder
        shadow="sm"
        sx={() => ({
          overflow: 'visible',
        })}
      >
        <ClientForm
          persons={persons}
          technologies={technologies}
          names={clients.map((t) => t.name)}
          buttonLabel="Add"
          onSubmit={(values: SubmittableClient) => addClient(values)}
          add
          successMessage="Client created"
        />
      </Card>
    </Center>
  );
};

export default NewClient;
